import Vue from 'vue';
import Hub from '~/hub.js';
import VueRouter from 'vue-router';
import store from '~/store/index.js';
import PageHeadComponent from '~/components/menu/page-head-component.vue';
import MenuStore from '~/store/modules/menu-store.js';

const ELEMENT = document.querySelector('.js-head');

const MenuComponent = () => import(
    /* webpackChunkName: "menu" */
    '~/components/menu/menu-component.vue'
).then(m => m.default);

const SearchComponent = () => import(
    /* webpackChunkName: "search" */
    '~/components/shared/search-component.vue'
).then(m => m.default);

Vue.use(VueRouter);

class Menu {
    constructor(element) {
        this.vm = this.createComponent(element);
        this.changeRoute = this.changeRoute.bind(this);
        this.addEvents();
    }

    createComponent(element) {
        store.registerModule('menu', MenuStore);

        return new Vue({
            name: 'Menu',
            render: h => h(PageHeadComponent),
            el: element,
            store
        });
    }

    addEvents() {
        Hub.subscribe(Hub.INIT_PAGE_HEAD_ROUTER, this.initRouter.bind(this));
    }

    initRouter() {
        this.vm.$options.router = this.createRouter();
        this.vm.$options.router.init(this.vm);
        Vue.util.defineReactive(this.vm, '_route', this.vm.$options.router.history.current);
        this.vm._router = this.vm.$options.router;

        if (document.readyState !== 'complete') {
            this.fixRouter();
        }
    }

    fixRouter() {
        //Fix for Vue Router bug https://github.com/vuejs/vue-router/issues/2320
        window.addEventListener('hashchange', this.changeRoute);
        window.addEventListener('load', this.disableRouterFix.bind(this));
    }

    changeRoute() {
        const name = this.vm.$route.name;
        const hash = window.location.hash;

        if ((name === 'menu' || name === 'search') && hash === '#/' ) {
            this.vm.$options.router.replace({ name: 'empty' });
        }
    }

    disableRouterFix() {
        window.removeEventListener('hashchange', this.changeRoute);
    }

    createRouter() {
        return new VueRouter({
            routes: [
                {
                    path: '/',
                    name: 'empty'
                },
                {
                    path: '/menu',
                    component: MenuComponent,
                    name: 'menu'
                },
                {
                    path: '/szukaj',
                    component: SearchComponent,
                    name: 'search'
                }
            ]
        });
    }
}

if (ELEMENT) {
    new Menu(ELEMENT);
}
